import { Children, type ReactNode } from 'react'

/**
 * Bir xil og'irlikdagi panellar qatori — YONIDA BO'SH JOY QOLDIRMAYDI.
 *
 * <h2>⚠️ NEGA `Row`/`Col` EMAS — o'lchangan sabab</h2>
 * Bosh sahifada besh panel `Col xl={6}` bilan yozilgan edi. `6 × 5 = 30`,
 * qator esa 24 ustun — ya'ni beshinchi panel HAR SAFAR yangi qatorga
 * tushardi va yonida bo'sh joy qolardi. O'lchov (2026-08-13, staging):
 *
 * <pre>
 *   1920px → «Tarmoqqa qo'llanmagan» 404px, o'ngida 1212px BO'SH (75%)
 *   1440px → 292px karta,             o'ngida  876px BO'SH (75%)
 *   1024px → 376px karta,             o'ngida  376px BO'SH (50%)
 * </pre>
 *
 * <h2>⚠️ IKKINCHI SABAB — HUQUQ TESHIGI</h2>
 * Panellarning bir qismi huquq yetmasa `null` qaytaradi
 * ({@code NetworkHealthPanel} — `nas.read`, {@code TopAgentsPanel} —
 * `agent.read`). `Col` esa BARIBIR chiziladi va o'z ustunini band qilib
 * turadi. O'lchangan holat: AGENT huquqlari bilan kirilganda qatorning
 * IKKINCHI o'rnida 404×197px mutlaqo bo'sh ustun turadi — panel yo'q,
 * joyi bor.
 *
 * Shuning uchun bu yerda `flex-wrap` ishlatiladi:
 * <ul>
 *   <li>oxirgi qatordagi kartalar qolgan joyni O'ZI to'ldiradi
 *       (`flex-grow`) — nechta panel bo'lishidan qat'i nazar;</li>
 *   <li>bo'sh qolgan o'ram `:empty` bo'yicha butunlay yashiriladi
 *       (`global.css`), ya'ni huquq teshigi joy egallamaydi.</li>
 * </ul>
 *
 * ⚠️ `:empty` ATAYLAB tanlandi — huquq shartini bu yerda TAKRORLAMASLIK
 * uchun. Sahifada «bu panel ko'rinadimi» degan ikkinchi ro'yxat paydo
 * bo'lsa, u panelning o'z shartidan ajralib ketardi va teshik qaytib
 * kelardi — faqat boshqa rolda.
 *
 * @param basis kartaning eng kichik qulay eni. 300px — o'lchangan:
 *   hozirgi paneldagi eng tor qulay holat 292px (1440px, to'rttalik
 *   qator) va u hali qirqilmaydi. Undan tor qilib qo'yish sarlavhani
 *   qirqadi (ilgari 8/8/4/4 da aynan shunday bo'lgan).
 */
export function PanelBand({ children, basis = 300 }: { children: ReactNode; basis?: number }) {
  return (
    <div className="xsib-band" style={{ ['--xsib-band-basis' as string]: `${basis}px` }}>
      {Children.map(children, (child) => (
        // ⚠️ O'ram MAJBURIY: `flex` xossalari aynan shunga qo'yiladi va
        // panel `null` qaytarganda AYNAN SHU o'ram `:empty` bo'ladi.
        <div>{child}</div>
      ))}
    </div>
  )
}
